import React from 'react';

import styles from './breadcrumb.scss';

function page(name, url, current, lang) {
  const urlsplit = url.split('/');
  const linkPage = urlsplit[3];
  // const linkPage = urlsplit[3]; // For production

  const isMain = current.length === 0;

  let isLink = linkPage !== current;
  isLink &= !isMain;

  if (isLink) {
    const params = lang == null ? '' : `?lang=${lang}`;

    return (
	  <a href={`${url}${params}`}>{name}</a>
    );
  } else {
    const isBold = !isMain || linkPage.length === 0;
    return (
	  <span style={isBold ? {fontWeight: 'bold'} : undefined}>{name}</span>
    );
  }
}

export default function breadcrumb(urls, current, lang) {
  if (current === 'downloadlist') {
    return (
      <div className={styles.breadcrumb}>
        {page('Top', urls.index, current, lang)}
	    &gt;
        {page('Download List', urls.downloadlist, current, lang)}
	  </div>
    );
  } else if (current === '') {
    return null;
  }

  return (
    <div className={styles.breadcrumb}>
      {page('Top', urls.index, current, lang)}
	  &gt;
      {page('Data Downloader', urls.downloader, current, lang)}
	  |
      {page('Time Series Viewer', urls.viewer1d, current, lang)}
	  |
      {page('Map Viewer', urls.viewer2d, current, lang)}
	  |
      {page('Data Analyzer', urls.statistics, current, lang)}
    </div>
  );
}
